import type { RootState } from "../store";

export const selectHolidayDates = (state: RootState) => state.holidays.dates;
